import { createCommand } from '@commander-js/extra-typings';
import type { AstroCommandServices } from '@wix/cli-command-contract';
import { translationPullCommand } from './translation-pull.js';
import { translationPushCommand } from './translation-push.js';

export const translationCommand = (
  services: AstroCommandServices,
  cliVersion: string
) => {
  return createCommand('translation')
    .description('Work with site translations')
    .addCommand(translationPullCommand(services, cliVersion))
    .addCommand(translationPushCommand(services, cliVersion));
};
